module.exports = __webpack_public_path__ + "media/images/landing_page/2023/album/album_mobile_ru-bd5206bc4b571ce5ab8a74cce0a3a0be.webp";